import { render, staticRenderFns } from "./NotificationstatusbySubscriberList.html?vue&type=template&id=6f47b528&scoped=true&external"
import script from "./NotificationstatusbySubscriberList.ts?vue&type=script&lang=ts&external"
export * from "./NotificationstatusbySubscriberList.ts?vue&type=script&lang=ts&external"
import style0 from "./NotificationstatusbySubscriberList.css?vue&type=style&index=0&id=6f47b528&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f47b528",
  null
  
)

export default component.exports